var keyMirror = require('./../../lib/keyMirror');

module.exports = keyMirror({
  UPLOADING: null,
  UPLOAD_FAIL: null,
  SENDING: null,
  CANCEL_SENDING:null,
  SUCCESS: null,
  FAIL: null,
  DOWNLOADING: null,
  DOWNLOADED: null,
  DOWNLOAD_FAIL: null,
  VIDEO_PLAY_ERROR: null
});
